export default __webpack_public_path__ + "locales/el-GR/ChangeUserTypeDialog.json?hash=005ea92d5ecfbc99c7e56ac18b009701";